import { PropsWithChildren } from "react";
import { ButtonProps } from "@chakra-ui/react";
import PrimaryButton from "components/PrimaryButton";

const SubmitButton = ({
  children,
  ...rest
}: PropsWithChildren<ButtonProps>) => (
  <PrimaryButton type="submit" {...rest}>
    {children}
  </PrimaryButton>
);

export default SubmitButton;
